import { Flex } from 'antd';
import styled from 'styled-components';
import { ImageContainer as CommonImageContainer } from '../../styles/commonStyles';

export const Container = styled(Flex)`
  width: 100%;
  &.checkable {
    padding: 16px;
    cursor: pointer;
  }
  &.checked {
    background: #f4f9ec;
  }
  &:hover {
    cursor: pointer;
  }
`;

export const ImageContainer = styled(CommonImageContainer)`
  width: 80px;
  height: 60px;
  background: #fff;
`;

export const CauseName = styled.p`
  font-weight: 500;
  margin: 0;
  line-height: 24px;
  font-size: 12px;
`;

export const Description = styled.p`
  margin: 0;
  line-height: 24px;
  font-size: 12px;
  color: #85878b;
`;

export const ActionButtonWrapper = styled.div`
  padding: 8px;
  color: #999b9e;
  &:hover {
    color: ${(props) => props.theme.antd?.colorPrimary};
  }
`;
